import type { RELEASE_NOTE_QUERYResult } from "generated/sanity.types";
import { useEffect, useState } from "react";
import { client } from "src/sanity/lib/client";
import { RELEASE_NOTE_QUERY } from "src/sanity/lib/queries";

export const useReleaseNote = (slug: string) => {
  const [releaseNote, setReleaseNote] = useState<RELEASE_NOTE_QUERYResult>();

  useEffect(() => {
    async function fetchReleaseNote() {
      const res = await client.fetch<RELEASE_NOTE_QUERYResult>(
        RELEASE_NOTE_QUERY,
        {
          slug,
        },
      );
      setReleaseNote(res);
    }
    void fetchReleaseNote();
  }, [slug]);

  return { releaseNote };
};
